module.exports = __webpack_public_path__ + "static/media/Aman.21c09d34.jpg";